/*
 * @Author: Wang hui
 * @Date: 2021-04-30 13:08:08
 * @LastEditTime: 2021-05-06 13:12:42
 * @LastEditors: Please set LastEditors
 * @Description: 路由配置
 * @FilePath: \Wjb-Website\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
        path: "/",
        name: '/',
        component: () => import('@/views/home/index.vue'),
        meta: {
            title: '无尽宝-只还本的分期购物',
        },
    },
    // {
    //     path: "/home",
    //     name: 'home',
    //     component: () => import('@/views/home/index.vue'),
    //     meta: {
    //         title: '无尽宝-只还本的分期购物',
    //     },
    // }, 
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router